var _this = this;
import { __assign } from "tslib";
import { currencyDecimals, DEFAULT_LANGUAGE } from '@concur/intl-core';
import numeral from 'numeral';
var getNumeralFormatter = function (locale, _a) {
    var numberSign = _a.numberSign, delimiters = _a.delimiters;
    var numeralLocale = __assign(__assign({}, numeral.locales[DEFAULT_LANGUAGE]), { delimiters: delimiters });
    var key = getNumeralKey(locale, numberSign, delimiters);
    registerNewLocaleWhenNeeded(key, numeralLocale);
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        numeral.locale(key);
        return numeral.apply(_this, args);
    };
};
function getNumeralKey(locale, numberSign, delimiters) {
    return "".concat(locale, "-").concat(numberSign, "-").concat(JSON.stringify(delimiters));
}
function registerNewLocaleWhenNeeded(key, numeralLocale) {
    try {
        // getting the localeData throws an error when the key isn't registered.
        numeral.localeData(key);
    }
    catch (e) {
        numeral.register('locale', key, numeralLocale);
    }
}
function getFormatStr(sign, opts, isCurrency, currencyPos) {
    if (opts === void 0) { opts = {}; }
    if (isCurrency === void 0) { isCurrency = false; }
    var signedFormat = getSignedFormat(sign, isCurrency, currencyPos);
    var _a = opts.decimals, decimals = _a === void 0 ? 0 : _a, _b = opts.maxDecimals, maxDecimals = _b === void 0 ? 0 : _b;
    var deciFormat = '0'.repeat(decimals);
    var maxDeciFormat = maxDecimals > decimals ? "[".concat('0'.repeat(maxDecimals - decimals), "]") : '';
    return signedFormat.replace('00', deciFormat) + maxDeciFormat;
}
function getSignedFormat(sign, isCurrency, currencyPos) {
    var baseFmt = '0,0.00';
    if (isCurrency) {
        if (sign === 'standard') {
            return currencyPos === 'after' ? "-".concat(baseFmt, " $") : "$ -".concat(baseFmt);
        }
        return currencyPos === 'after' ? "(".concat(baseFmt, " $)") : "($ ".concat(baseFmt, ")");
    }
    return sign === 'accounting' ? "(".concat(baseFmt, ")") : "-".concat(baseFmt);
}
function getCurrencyFormatStr(currencyPref, options) {
    var _a, _b, _c;
    var decimals = (_b = (_a = options.decimals) !== null && _a !== void 0 ? _a : currencyDecimals[options.currency]) !== null && _b !== void 0 ? _b : 2;
    var maxDecimals = (_c = options.maxDecimals) !== null && _c !== void 0 ? _c : decimals;
    return getFormatStr(currencyPref.currencySign, { decimals: decimals, maxDecimals: maxDecimals }, true, currencyPref.symbolLocation);
}
export { getFormatStr, getNumeralFormatter, getCurrencyFormatStr };
